// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useEffect, useState} from 'react';
import cn from 'classnames';
import {Text} from './text';
import {Icon} from './icon';
import '../css/loader.less';

export function Loader({
    className,
    size='m',
    label,
    page_height,
    delay_ms=250,
})
{
    const [show, set_show] = useState(false);
    useEffect(()=>{
        const timer = setTimeout(()=>set_show(true), delay_ms);
        return ()=>clearTimeout(timer);
    }, [delay_ms]);
    if (!show)
        return null;
    return <div className={cn('sdk-loader', page_height&&'sl-page-heigth',
      className)}>
      <div className="sl-wrapper">
        <Icon name="ico_spinner" color="main" size={size}/>
        {!!label&&<Text.m>{label}</Text.m>}
      </div>
    </div>;
}
